<template>
  <div class="animated fadeIn">

    <!-- Modal que informa que la licencia del sistema no esta aceptada aun por el responsable. -->
    <ModalAlertNotAccepted />

    <!-- Modal para ver detalles de la licencia. -->
    <ModalDetailsAndConfirmation />

    <!-- Informe sonbre el estado de la licencia -->
    <div class="card card-body text-center shadow-sm" v-if="licencia != null && !isSuperAdmin && licencia.is_license_accepted == 0">
      <strong>
        <i class="fa fa-info-circle " /> El responsable debe aceptar el contrato de
        la licencia para el uso de Soluquim.

        <b-button
          v-if="userActiveInLicense"
          class="mr-3 ml-2"
          variant="outline-primary"
          @click="openModalSeeDetailsLicense"
        >
          Ver licencia
          <i class="fa fa-arrow-right" />
        </b-button>

      </strong>
    </div>

    <!-- Titulo y Logo -->
    <div class="d-flex justify-content-start align-items-center container-logo mb-4">

      <!-- Logo -->
      <div class="d-flex justify-content-center align-items-center">
        <b-img fluid
          :src="selectedImagen.imagen"
          :class="selectedImagen.orientacion"
          alt="Logo"
          class="logo-empresa"
        />
      </div>

      <!-- Titulo -->
      <div class="ml-3 container-logo-titles">
        <h2 class="Bienvenido titulos">Bienvenid@ a Soluquim</h2>
        <h5 class="d-block">{{ usuario }}</h5>
      </div>
    </div>

    <b-row>
      <b-col sm="12">
        <SistemasClasificacion></SistemasClasificacion>
      </b-col>
      <b-col sm="12">
        <Graficas v-if="!showGraphics"></Graficas>
      </b-col>
      <b-col sm="12"></b-col>
    </b-row>
  </div>
</template>

<script>
import {mapState, mapActions, mapMutations} from 'vuex';
import {getAcls} from '../plugins/acl';
import Graficas from './graficas/Graficas';
import SistemasClasificacion from './graficas/SistemasClasificacion';
import Tarjetas from './graficas/Tarjetas';
import loader from '../containers/loader';
import ModalAlertNotAccepted from './empresa/licencias/acceptLicense/ModalAlertNotAccepted.vue'
import ModalDetailsAndConfirmation from './empresa/licencias/acceptLicense/ModalDetailsAndConfirmation.vue'

export default {
  name: 'dashboard',
  data: function () {
    return {
      showGraphics: false,
      userResponsibleId: '',
      isSuperAdmin: false
    };
  },
  components: {
    Graficas,
    SistemasClasificacion,
    Tarjetas,
    loader,
    ModalAlertNotAccepted,
    ModalDetailsAndConfirmation
  },
  async mounted() {
    this.setModalAcceptLicense(false);
    this.setModalDetailsLicence(false);

    this.load(true);
    var acls = getAcls();
    //this.establerIdEmpresaLicencia(acls.empresa)
    //await this.licenciasPorCaducar()
    let rol = acls.roles.toString();

    if (rol == 'admin' || rol == 'superadmin') {
      this.showGraphics = true;
    } else if (rol == 'empresa-contratista') {
      this.showGraphics = true;
    }

    await this.asignaEmpresaDash(acls.empresa);

    this.resetImagen();

    if (this.selectedImagen.imagen == '') {
      await this.getImagen({
        companyId: this.filtro.empresa,
        module: 'HOME'
      });
    }

    if (acls.info_empresa) {
      const empresa = acls.info_empresa;

      if (empresa.banner) {
        await this.obtenerImagenesBanner(empresa.id);

        if (!!this.imagenes_banner.length) {
          this.establecerModalBanner(true);
        }
      }
    }
    await this.setUsuario(acls.user);
    this.userResponsibleId = acls.usuario_id;

    //graficas
    if (!this.showGraphics) {
      await this.resetSelectedGraficas();
      await this.resetSelectedGraficasFdsMsds();
      await this.getGraficas();
      await this.getFdsMsds();
    }

    await this.notificationsUnread()

    // verificar si la licencia del sistema esta aprobada y cargar sus datos
    const license = {
      companyId: acls.empresa,
      userActiveId: acls.usuario_id
    }
    const findRol = acls.roles.find(x => x == "superadmin");
    if (!findRol) await this.checkSystemLicenseIsApproved(license);
    else this.isSuperAdmin = true

    this.load(false);
  },
  computed: {
    ...mapState('dashboard', ['filtro', 'usuario', 'selectedGraficas', 'loading', 'estadoContratoDeLicencia']),
    ...mapState('banners', ['imagenes_banner']),
    ...mapState('empresa', [
      'selectedImagen',
      'listadoOrientaciones',
      'edicionUsuario',
      'imagenCargada',
    ]),
    ...mapState('licencias', [
      'licencia',
      'modalAcceptLicense',
      'modalDetailsLicense',
    ]),
    userActiveInLicense() {
      return this.userResponsibleId == this.licencia.responsible_user_id ? true : false
    }
  },
  methods: {
    ...mapMutations('banners', ['establecerModalBanner']),
    ...mapActions('banners', ['obtenerImagenesBanner']),
    ...mapActions('empresa', ['getImagen', 'getUsuario']),
    ...mapActions('dashboard', ['getGraficas', 'getFdsMsds', 'notificationsUnread']),
    ...mapActions("licencias", [
      "checkSystemLicenseIsApproved"
    ]),
    ...mapMutations('dashboard', [
      'asignaEmpresaDash',
      'setUsuario',
      'resetSelectedGraficas',
      'resetSelectedGraficasFdsMsds',
      'load',
    ]),
    ...mapMutations('empresa', ['resetImagen']),
    ...mapMutations('licencias', [
      'establerIdEmpresaLicencia',
      'setModalAcceptLicense',
      'setModalDetailsLicence',
      'setIsVisibleDetailsLicensingContract',
    ]),
    openModalSeeDetailsLicense() {
      this.setIsVisibleDetailsLicensingContract('close')
      this.setModalDetailsLicence(true)
    }
  },
};
</script>

<style scoped>
.Horizontal {
  display: block;
  margin: auto;
  margin-bottom: 5px;
  width: 278px;
  object-fit: contain;
  min-width: 278px;
  height: 178px;
}

.Vertical {
  display: block;
  margin: auto;
  width: 200px;
  margin-bottom: 5px;
  object-fit: contain;
  height: 200px;
}

@media (min-width: 0px) and (max-width: 600px) {
  .Horizontal {
    width: 100%;
  }
  .Vertical {
    width: 350px;
    height: 350px;
  }
  .container-logo{
    display: block !important;
  }
  .container-logo-titles{
    text-align: center !important;
  }
}

.Bienvenido {
  font-weight: bold;
  text-align: center;
}

.logo-empresa {
  border-radius: 10px;
  filter: drop-shadow(0 0 8px #ccc);
}

.container-logo {
  box-shadow: 0 0 2px #ccc;
  padding: 20px 32px;
  background: white;
}

.titulos {
  text-align: center;
}
</style>
